// extracted by mini-css-extract-plugin
export default {"container":"Calendar_container__EVNYG","ico":"Calendar_ico__RPt31","-calendar":"Calendar_-calendar__9oJSA"};